import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import httpService from './httpService';

// https://hawak-dev-public.s3.me-south-1.amazonaws.com/hawak-dev/local/master/en.json
export const getFirstLanguage: any = createAsyncThunk<any>(
	'getFirstLanguage',
	async (languageCode: any) => {
		const response = await axios.get(
			`${process.env.REACT_APP_MASTER_LANGUAGE_JSON}/master/${languageCode}.json`
		);
		return response;
	}
);
export const getSecondLanguage: any = createAsyncThunk<any>(
	'getSecondLanguage',
	async (languageCode: any) => {
		const response = await axios.get(
			`${process.env.REACT_APP_MASTER_LANGUAGE_JSON}/master/${languageCode}.json`
		);
		return response;
	}
);
export const getSampleCSV: any = createAsyncThunk<any>(
	'getSampleCSV',
	async (languageCode) => {
		const response = await axios.get(
			`${process.env.REACT_APP_MASTER_LANGUAGE_JSON}/master/${languageCode}.json`
		);
		//chages suggested by client
		// const response = await httpService.get(`/language/sample-csv`);
		return response?.data;
	}
);
export const getLanguagesListWithPagenation: any = createAsyncThunk<any>(
	'getLanguagesListWithPagenation',
	async (data: any) => {
		const response = await httpService.get('common/language', {
			params: data
		});
		return response.data;
	}
);
export const addKey: any = createAsyncThunk<any>(
	'addKey',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post('/language/key', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const editKey: any = createAsyncThunk<any>(
	'editKey',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put('/language/key', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const editLanguage: any = createAsyncThunk<any>(
	'editLanguage',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.put('/language', data);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const addLanguage: any = createAsyncThunk<any>(
	'addLanguage',
	async (data: any, { rejectWithValue }) => {
		try {
			const response = await httpService.post('/language', data);
			return response.data;
		} catch (error: any) {
			console.log(error?.response?.data, 7171);
			return rejectWithValue(error?.response?.data);
		}
	}
);
export const deleteKeys: any = createAsyncThunk<any>(
	'deleteKeys',
	async (data: any, { rejectWithValue }: any) => {
		try {
			const response = await axios.delete(
				`http://localhost:3510/language/key`,
				{
					headers: {
						"Authorization":"eyJraWQiOiJUMFh0dEFpSnJYNExRcGlmVWpZVHFSZXZhYmFLZmpwS1pURSt1RG8rZytnPSIsImFsZyI6IlJTMjU2In0.eyJzdWIiOiIyNTNjNDkzZS0yNWM0LTQyMzQtODdjMS0zNjM0MmExZmQ4ZjEiLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAubWUtc291dGgtMS5hbWF6b25hd3MuY29tXC9tZS1zb3V0aC0xX20zS0UzY0lDZiIsImNsaWVudF9pZCI6IjYwaXRoa3RvNHVvbDltMDZwcWE4cjRpN3NmIiwib3JpZ2luX2p0aSI6IjEwNzU0OWY2LWM1NWItNGZjNC1hODBkLWZkNTA4YmQ5YzMxMyIsImV2ZW50X2lkIjoiMDAzODAwNzUtN2ZlZS00MjViLThkYmQtNjU1Y2VkODU3YzY3IiwidG9rZW5fdXNlIjoiYWNjZXNzIiwic2NvcGUiOiJhd3MuY29nbml0by5zaWduaW4udXNlci5hZG1pbiIsImF1dGhfdGltZSI6MTY3NzQ3NzkxNCwiZXhwIjoxNjc3NTA2NzgzLCJpYXQiOjE2Nzc0Nzc5ODMsImp0aSI6IjRjNDRhOTIxLTEwMmEtNGNiZi05OTNjLWVmMjBmYTc4NjVhMiIsInVzZXJuYW1lIjoiMjUzYzQ5M2UtMjVjNC00MjM0LTg3YzEtMzYzNDJhMWZkOGYxIn0.OLQnOjazFzdF3FjFaJlhsNG8GoAyelfPIG6Vupbn3RVV6_86EI0NkMId5fTuwpcgqGtQ19Bzm2p6x73UzXHWSX5IMBPUJTIaLMOfpYJdqnrNi_wadsDUdvisO0xFy0Cpv60PM5mjZd7V0DAPM3balr16YMY71dhSmQ5XJR4wDE6LibZSDCFiKGxKOMUAZRpTBHPy453NNc8bds0JOU_6qkn4j30WCHj_nWpF3a6hUkAHRDo7uCGpxFR1oWKBiTEOOXxSUH8wDS7nt3kc3e0aRJJnY8ISktpQV022ri6bFp7dCfDlsxu-X4OSx7p6V-2LBSOCvDkLYaofzyC8HGiSvg",
						"refreshtoken" : "eyJjdHkiOiJKV1QiLCJlbmMiOiJBMjU2R0NNIiwiYWxnIjoiUlNBLU9BRVAifQ.gD0O8swzTriAcyPllem7716klvzbrg5Z9GqZAfiDSeAEO_VJgXLIyAxBIXbbqyr_hKMxpz_AukyaedEnDbv8evnFOTwZniZ0_GNNcA7jmqjAkxvxTbkE9YYzAohobRBiU1GAxgLPiqG_Jn14bdwJHlGrH-b2E4sZ_zxN_NMNXzF1ak3b4JcIywaB2n9wzdlkZl_9kQhw_1tkSGO3iGcC_ziuzk_Kj-SIL0IHA158sRxAX4DO6zdYHpigbc2dOgqr6osp1VgMMv1oE15Xwd-hIm9uGyggVejue_VbgAi33pwPyQXqbU11X1DFt1WmmL7DfDGF_I7dv4qR8JP-z5t63A.IAVfxYV7jGCYJrT6.dd1iMagZiDzvITbdZKsyN1xHHfRXNPeFL1p6NCWFIy3_Xn9EgE0esFrUp65JVLG_RBDzEaSLdN40A4NRBX5083SzgVRrpr8aFeg8FqdXjnFJdnRs_wInJEIXsZuZwVxG05RTHsg5xXmI8yC3LQaND1OJC7gOfkTHn1wdlnANpbmwrHSVgphPaS69gKGilvVzedN-mWFs85-twkqF6VckIhsoAcUlOQSfdWZBzfyDQ0movR9zSeqYx03S8HijvzVa76GBUL4jEWFkWtq2HF5k-qj2S2bfkMN13UuNDliK5mnAuDOrX1M_-DTuDI9mcDEMXk1SDlSEhVh7kE3AR2IrKflRe0NSvfrjyFem_g5tlwZeUVRwEHuze_VS9BOLSI8W5GtdC6H1v9D5ODP8yTL_8FAHkRW1ZD8HHNOSWnR79OMhMgl9Xp1d2MnyD8YnVG_bHP0H8Em8Lb3oaIN-3nOdoSzqlfYxZxagcyDi0ybP7Y2DosCMOJqp_v5-3Veus29HdWL62WcOKtdXABwhhI7lMBBZw-7hrmqmEctrRLg2BMaXy3zvRmOjjo79tlzU3DlVE7yhYGB4-Wge3h7Tx-2xTpYoOqzEtVu671H3j1rDmfYvJykmqYDCxS7rGEf7Rhvo-XJ8iPVQJ6Ey25HLkK6wKx0aPc_XO_6jeMS9HsPRX5jJGR6UGI4whYIlKw0yyWxm4hFo-YgIsagead7iDfoRgp-_x6jZEz_CjNL9e48-KcRL4pI6ZMv4G4zF0E2OO05C8SdsJUq3W49SMEptYYpJfqeVL12x0pTjtcVa12b37D3RPvuVbW6TX3HPPaI0rHNT3HExX_TP84L8NVzd9hwDkIoYOpDZpt-3jOfsN8HpTN5qkV8e4rr0G0-uXslJfKAPkLS7VN9SwcavzLkw0Zey8b_-4Eu3wYNPfyBeghwSMnFaHbYZfk_wHZNrevx5h9vcEq9iH1TepDrriYmPtfeg6HuxwfUiP6e5-4fLAabIcZzzlamq76b_PcfH8OaG0t7fy0yXMs67_P6t2BuvCW34GvamrZiig9Mj6jmBhzJKgFJ4cydi5Hi59Dp5TxSleT8bZ1OwAc4iIxDlzMe4ZlkE07wOWOg-TdKOyAVa-ckHwSCd57v4rrojfAKxDPjQriONjh9OQcj4nFhf3iHDLzhUXCMV_8r29sdlzDYqsBV_gJp2ss4DAydOv_ZKAvI4t_BQFj0YzMDbl9q5kLE9vrvZHvtsW5iIsgKlv8BO0KtYqdNIafQltpAQEolP1HpOdswyNEkMMqvMJu63oX8wvCyMd3DFTtmqZqqbp5gvoBS1GPWiGWKPISLWu08dSyx-QA.G4SvTm7BX55VnGkIZ3LJkA",
						"devicetoken" : "ee7e0dfe-1c8f-4e13-86b0-8ce4d7bad86c",
						"userroleid": "632455a36651cd00804becb0"
					},
					params: { key: data }
				}
			);
			return response.data;
		} catch (error: any) {
			return rejectWithValue(error?.response);
		}
	}
);